import { PLATFORMS } from "@/constants";

export default {
  computed: {
    platform() {
      return (
        this.$route.params.platformKey ||
        this.$route.params.workspaceKey ||
        PLATFORMS.ESSAYGRADER // serves for manual upload
      );
    },
    isLMS() {
      return PLATFORMS.ESSAYGRADER !== this.platform;
    },
  },
};
